import React from 'react';
import PropTypes from 'prop-types';
import { RouteChildrenProps } from 'react-router';

import { UserStore } from 'four-nets/user/user';
import { FourNetsApi } from 'four-nets/api/api';
import { ProductStore } from 'four-nets/bazaar/bazaar';

import Products from '../products/products';
import CategoriesView from './categories-view';

interface Params {
    slug?: string;
}

interface Search {
    page?: number;
    orderBy?: string;
    price?: string;
    county?: string | string[];
    search?: string;
    excludeVendor?: boolean;
    excludeUsed?: boolean;
}

export interface Props extends RouteChildrenProps<Params> {
    search: Search;
}

class BazaarCategoriesHomepage extends React.PureComponent<Props> {
    static contextTypes = {
        api: PropTypes.instanceOf(FourNetsApi),
        userStore: PropTypes.instanceOf(UserStore),
        authCheck: PropTypes.func,
    };

    render() {
        const { api, userStore, authCheck } = this.context;
        const productStore = new ProductStore({ api, userStore });

        const { slug } = this.props.match?.params || {};
        const { county, price } = this.props.search;

        return (
            <>
                <CategoriesView
                    county={county}
                    price={price}
                    slug={slug}
                    hasActiveFilters={county || price ? true : false}
                    productStore={productStore}
                    authCheck={authCheck}
                />
                <Products
                    categorySlug={this.props.match?.params?.slug}
                    hasActiveFilters={this.props.search?.county || this.props.search?.price ? true : false}
                />
            </>
        );
    }
}

export default BazaarCategoriesHomepage;
